import { render, staticRenderFns } from "./baseButton.vue?vue&type=template&id=0ddacfc0&scoped=true"
import script from "./baseButton.vue?vue&type=script&lang=js"
export * from "./baseButton.vue?vue&type=script&lang=js"
import style0 from "./baseButton.vue?vue&type=style&index=0&id=0ddacfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddacfc0",
  null
  
)

export default component.exports